import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const msg = {
    ...zhLocale,
    'Home':'首页',
    'Products':'产品中心',
    'Products Center':'产品中心',
    'News':'新闻',
    'News Updates':'新闻更新',
    'Our Department':'我们的部门',
    'Keep In Touch':'保持联络',
    'Tel':'电话',
    'Email':'邮箱',
    'Address':'地址',
    'We\'d Love To Hear From You':'欢迎随时联系我们',
    'Last Name':'姓',
    'First Name':'名',
    'Telephone':'电话',
    'Country':'国家',
    'Additional Information':'附加信息',
    'Submit':'提交',
    'Contacts Us':'联系我们',
    'E-MAIL':'电子邮件',
    'TEL':'电话',
    'Previous':'上一篇',
    'Next':'下一篇',
    'Latest News':'最新新闻',
    'FTTx':'光纤到户',
    'Data Center':'数据中心',
    'Customized':'定制服务',
    'FTTx Solution':'光纤到户解决方案',
    'Data Center Solution':'数据中心解决方案',
    'Customized Solution':'定制服务',
    'Specification':'规格',
    'Ordering Information':'订购信息',
    'Requirement':'定制与订购选项',
    'Product Highlights':'产品亮点',
    'Related Products':'相关产品',
    关于我们:'关于我们',
    解决方案:'解决方案',
    产品中心:'产品中心',
    发展历程:'里程碑',
    公司简介:'公司简介',
    组织架构:'组织架构',
    我们的部门:'我们的部门',
    荣誉资质:'证书与荣誉',
    产品展示:'我们的产品',
    查看更多:'查看全部',
    更多:'更多',
    新闻资讯:'新闻',
    公司新闻:'公司新闻',
    行业新闻:'行业新闻',
    联系我们:'联系我们',
    产品分类:'产品分类',
    所有产品:'所有产品',
    光纤连接器:'光纤连接器',
    光纤适配器:'光纤适配器',
    光纤衰减器:'光纤衰减器',
    光纤配线架:'光纤配线架',
    其他产品:'其他产品',
    搜索:'请输入关键字',
    关闭:'关闭',
    查看全部:'查看全部',
    版权所有:'Copyrights © 2020 - ZHEJIANG JIAWEI COMMUNICATION',
    加载更多:'加载更多',
    产品证书:'产品证书',
    '提交成功，我们会尽快与您联系！':'提交成功，我们会尽快与您联系！',
    '提交失败，请稍后重试':'提交失败，请稍后重试',
}
export default msg;
